import { APIS, URLS } from '@/shared/config/urls';
import type { ApiResponse } from '@/shared/types/abstract-api-response';
import type { TrafficEventData, TrafficEventTimeData } from '@/shared/types/traffic-event';
import { request } from '@/shared/utils/request';

export const fetchTrafficEventTime = async (
  params: string = ''
): Promise<ApiResponse<TrafficEventTimeData[]>> => {
  const url = `${URLS.BACK_DSH}${APIS.trafficEventTime(params)}`;
  return await request.get<ApiResponse<TrafficEventTimeData[]>>(url);
};

export const fetchTrafficEvent = async (id: string): Promise<ApiResponse<TrafficEventData>> => {
  const url = `${URLS.BACK_DSH}${APIS.trafficEvent(id)}`;
  return await request.get<ApiResponse<TrafficEventData>>(url);
};
